module.exports = __webpack_public_path__ + "static/media/window-black.64d2a8b6.svg";